import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'react-fast-compare';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { seek } from 'src/common/actions/player';
import secondsToTime from 'src/common/utils/secondsToTime';
import playerStatuses from 'src/common/utils/playerStatuses';

import DefaultScrubber from './DefaultScrubber';
import LiveSeekScrubber from './LiveSeekScrubber';

const sliderMax = 100;

export class Scrubber extends Component {
  static propTypes = {
    positionInfo: PropTypes.object.isRequired,
    prerollPositionInfo: PropTypes.object.isRequired,
    isPrerollPlaying: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    isInNowPlayingDialog: PropTypes.bool,
    isMobile: PropTypes.bool,
    canScrub: PropTypes.bool,
    showStartEnd: PropTypes.bool,
  };

  static defaultProps = {
    positionInfo: {},
  };

  constructor(props) {
    super(props);

    this.state = this.getPositionState();
    this.onChangeCommitted = this.onChangeCommitted.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { positionInfo, prerollPositionInfo, isPrerollPlaying } = this.props;
    const isPrerollPosUpdate =
      isPrerollPlaying &&
      !isEqual(prerollPositionInfo, prevProps.prerollPositionInfo);

    if (!isEqual(positionInfo, prevProps.positionInfo) || isPrerollPosUpdate) {
      const duration = isPrerollPosUpdate
        ? prerollPositionInfo.duration
        : positionInfo.duration;
      const isLiveSeekStream = isPrerollPosUpdate
        ? false
        : positionInfo.isLiveSeekStream;

      if (!duration && isLiveSeekStream) {
        return;
      }

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(this.getPositionState());
    }
  }

  onChangeCommitted(scrubbingPercent) {
    this.props.actions.seek(scrubbingPercent);
  }

  getPositionState() {
    const { prerollPositionInfo, positionInfo, isPrerollPlaying } = this.props;
    const posInfoToUse =
      isPrerollPlaying && !isEmpty(prerollPositionInfo)
        ? prerollPositionInfo
        : positionInfo;

    const { duration, elapsedPercent, elapsedSeconds, isLiveSeekStream } =
      posInfoToUse;

    return {
      elapsedPercent: elapsedPercent || 0,
      elapsedSeconds: elapsedSeconds || 0,
      isLiveSeekStream,
      elapsedTime: secondsToTime(elapsedSeconds || 0),
      durationTime: secondsToTime(duration || 0),
    };
  }

  render() {
    const {
      elapsedTime,
      durationTime,
      elapsedPercent,
      elapsedSeconds,
      isLiveSeekStream,
    } = this.state;

    const {
      isMobile,
      canScrub,
      showStartEnd,
      isInNowPlayingDialog,
      isPrerollPlaying,
    } = this.props;

    if (isLiveSeekStream && !isMobile) {
      return (
        <LiveSeekScrubber
          sliderMax={sliderMax}
          elapsedTime={elapsedTime}
          durationTime={durationTime}
          elapsedPercent={elapsedPercent}
          elapsedSeconds={elapsedSeconds}
          onChangeCommitted={this.onChangeCommitted}
        />
      );
    }

    return (
      <DefaultScrubber
        sliderMax={sliderMax}
        elapsedTime={elapsedTime}
        durationTime={durationTime}
        elapsedPercent={elapsedPercent}
        elapsedSeconds={elapsedSeconds}
        onChangeCommitted={this.onChangeCommitted}
        isInNowPlayingDialog={isInNowPlayingDialog}
        isPrerollPlaying={isPrerollPlaying}
        canScrub={canScrub}
        showStartEnd={showStartEnd}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      seek: (percentage) => dispatch(seek(percentage)),
    },
  };
}

function mapStateToProps(state) {
  const prerollPlayerState = get(state, 'preroll.playerState');
  const { canScrub, showStartEnd } = state.player;
  const { playing, loaded } = playerStatuses;
  const isPrerollPlaying =
    prerollPlayerState === playing || prerollPlayerState === loaded;
  return {
    positionInfo: state.player.positionInfo,
    prerollPositionInfo: state.preroll.timeData,
    isPrerollPlaying,
    isMobile: state.app.isMobile,
    canScrub,
    showStartEnd,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Scrubber);
